<app-mas-garantia-header></app-mas-garantia-header>
<app-mas-garantia-navbar>
    <app-banner></app-banner>
    <div class="contrainer grey px-2 px-lg-5 d-flex justify-content-center flex-column pb-5">
        <div class="text-center my-4 my-md-5 fs-3">
            <p class="m-0"> {{ 'PRIVACY_POLICY.LABEL1' | translate }} </p>
        </div>

        <div class="row white py-4 px-3 mx-0 rounded shadow-sm">

            <div class="col-12 p-0 m-0">

                <div class="row m-0">
                    <div class="col-12">
                        <h6 class="fw-bold pb-2"> {{ 'PRIVACY_POLICY.LABEL2' | translate }} </h6>
                        <p>
                            {{ 'PRIVACY_POLICY.LABEL3' | translate }} 
                            <a class="link" href="www.liverpool.com.mx"> {{ 'PRIVACY_POLICY.LABEL4' | translate }} </a> 
                            {{ 'PRIVACY_POLICY.LABEL5' | translate }} 
                        </p>
                    </div>
                </div>

            </div>

            <div class="col-12 p-0 m-0">

                <div class="row m-0">
                    <div class="col-12">
                        <h6 class="fw-bold pb-2"> {{ 'PRIVACY_POLICY.LABEL6' | translate }} </h6>
                        <p>
                            {{ 'PRIVACY_POLICY.LABEL7' | translate }} 
                            <a class="link" href="www.assurant.mx/páginas-legales/Avisos-de-privacidad">{{ 'PRIVACY_POLICY.LABEL8' | translate }}</a>
                            {{ 'PRIVACY_POLICY.LABEL9' | translate }} 
                        </p>
                    </div>
                </div>

            </div>

        </div>

    </div>
</app-mas-garantia-navbar>
<app-mas-garantia-footer></app-mas-garantia-footer>